import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import cn from 'classnames'

import lang from 'lang'
import { replace } from 'common/utils'

import NudgeTask from './task'

export default class NudgeSet extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    nudgeSet: PropTypes.object.isRequired,
    nudgeType: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    // Only the first item should be open by default
    this.state = { active: this.props.index === 0 || false }
  }

  get tasksLeft() {
    return _.sumBy(this.props.nudgeSet.nudges, ({ completed_nudge }) => !completed_nudge)
  }

  toggleTab() {
    this.setState((prevState) => ({ active: !prevState.active }))
  }

  renderTasksLeft() {
    if (!this.tasksLeft) {
      return lang.dashboard.nudges.allCompleted
    }
    if (this.tasksLeft === 1) {
      return lang.dashboard.nudges.oneTaskToComplete
    }
    return replace(lang.dashboard.nudges.tasksToComplete, [this.tasksLeft])
  }

  render() {
    const { index, nudgeSet, nudgeType } = this.props
    const showNote = index === 0

    // Setup step is visible only in Assignment mode
    // Disable setup step for everyone that visits the roadmap
    if (nudgeType.slug === 'setup') {
      return null
    }

    return (
      <li className={cn('accordion-item', { 'is-active': this.state.active })}>
        <a
          onClick={() => this.toggleTab()}
          onKeyDown={() => this.toggleTab()}
          tabIndex="0"
          className="accordion-title"
          aria-controls="accordion"
          role="tab"
          aria-expanded="true"
          aria-selected="true">
          <h3 className="nudges-group-title">
            <span>{`${nudgeType.name} ${nudgeSet.index.toString().padStart(2, '0')}`}</span>
            <div>{nudgeSet.title}</div>
          </h3>
          <p className={cn('nudges-counter', { done: !this.tasksLeft })}>
            {this.renderTasksLeft()}
          </p>
          <p className="nudges-desc">{nudgeSet.description}</p>
        </a>
        <div
          className="accordion-content"
          role="tabpanel"
          aria-labelledby="accordion-label"
          aria-hidden="false"
          style={{
            display: this.state.active ? 'block' : 'none',
          }}>
          <ul className="nudges-task-list">
            {_.map(nudgeSet.nudges, (task) => (
              <NudgeTask key={task.id} task={task} nudgeSet={nudgeSet} showAction showStats />
            ))}
          </ul>
          {showNote ? (
            <p>
              <small>
                <strong>{lang.dashboard.nudges.completedNote}</strong>
              </small>
            </p>
          ) : null}
        </div>
      </li>
    )
  }
}
